import Markdown from 'components/markdown';
import Image from 'modules/content-cms/sections/components/image';
import renderDocument from 'modules/content-cms/util/render-document';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { IBlogPostFields } from '../../../../global';
import { formatDate, getMagazineUrl } from '../../util';

interface InFocusProps {
  article: IBlogPostFields;
}

const InFocus: React.FC<InFocusProps> = ({ article }) => {
  const { locale } = useRouter();
  return (
    <Link
      href={getMagazineUrl(
        {
          mainCategory: article.mainCategory.fields,
          subCategory: article.subCategory.fields,
          blogPost: article,
        },
        false,
        locale
      )}
    >
      <div
        className={
          'border-primary-main flex min-h-108 cursor-pointer flex-col rounded-2xl border-2 lg:min-h-68 lg:flex-row lg:hover:shadow-lg'
        }
      >
        <div className={'relative h-48 lg:h-auto lg:flex-1'}>
          <Image
            {...article.blogImage}
            className="rounded-t-xl lg:rounded-none lg:rounded-l-xl"
            data-test="blog-image"
            layout={'fill'}
            objectFit={'cover'}
            placeholder={'blur'}
            blurDataURL="/images/petsdeli-logo.svg"
          />
        </div>
        <div className={'relative flex-1 px-6 py-2'}>
          <div className={'text-primary-main mb-4 block text-2xl font-black'}>
            <h3>{article.title}</h3>
          </div>
          <div className={'line-clamp-2'}>
            <Markdown>{renderDocument(article.description)}</Markdown>
          </div>

          <div className={'absolute right-0 bottom-0 px-6 py-2 uppercase'}>
            {formatDate(article.publishDate)}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default InFocus;
